'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

import MarketYourTransactionsLayout from '../MarketYourTransactionsLayout'

const MarketYourTransactionsError = () => {
  return (
    <MarketYourTransactionsLayout>
      <ErrorDataUnavailable minHeight="478px" />
    </MarketYourTransactionsLayout>
  )
}

export default memo(MarketYourTransactionsError)
